import script from "./EnvioSearchComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvioSearchComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EnvioSearchComponent.vue?vue&type=style&index=0&id=1f477bb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f477bb3"]])

export default __exports__